"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _SourceUploadStatus = require("../../constants/SourceUploadStatus");
var _UploadStatusPane = require("./UploadStatusPane.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * get the status and the header of the modal
 */
var getUploadContent = function getUploadContent(uploadStatus) {
  if (uploadStatus.every(function (uploadStatusItem) {
    return uploadStatusItem.status === _SourceUploadStatus.UPLOADED;
  })) {
    return {
      'status': _SourceUploadStatus.UPLOADED,
      'header': 'Successful'
    };
  }
  if (uploadStatus.some(function (uploadStatusItem) {
    return uploadStatusItem.status === _SourceUploadStatus.UPLOAD_FAILED;
  })) {
    return {
      'status': _SourceUploadStatus.UPLOAD_FAILED,
      'header': 'Failed'
    };
  }
  return {
    'status': _SourceUploadStatus.UPLOADING,
    'header': 'Uploading'
  };
};

/**
 * show the set of freshly uploaded files
 */
var UploadStatusPane = function UploadStatusPane(_ref) {
  var isVisible = _ref.isVisible,
    uploadStatus = _ref.uploadStatus,
    onPanelClose = _ref.onPanelClose;
  var _getUploadContent = getUploadContent(uploadStatus),
    status = _getUploadContent.status,
    paneHeader = _getUploadContent.header;
  var iconMap = {
    UPLOADED: _freeSolidSvgIcons.faCheckCircle,
    FAILED: _freeSolidSvgIcons.faExclamationTriangle
  };
  (0, _react.useEffect)(function () {
    var timeoutId;
    if (uploadStatus.every(function (uploadStatusItem) {
      return [_SourceUploadStatus.UPLOADED, _SourceUploadStatus.UPLOAD_FAILED].includes(uploadStatusItem.status);
    })) {
      timeoutId = window.setTimeout(onPanelClose, 4000);
    }
    return function () {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [uploadStatus, onPanelClose]);
  return isVisible && _react["default"].createElement(_UploadStatusPane.StyledUploadStatusWrapper, null, _react["default"].createElement(_UploadStatusPane.StyledUploadStatusHeader, null, _react["default"].createElement(_UploadStatusPane.StyledUploadStatusHeaderBody, null, paneHeader), _react["default"].createElement(_UploadStatusPane.StyledUploadStatusCloseButton, {
    onClick: onPanelClose
  }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTimes
  }))), _react["default"].createElement(_UploadStatusPane.StyledUploadStatusList, {
    status: status
  }, uploadStatus.map(function (source, index) {
    return _react["default"].createElement(_UploadStatusPane.StyledUploadStatusListItem, null, _react["default"].createElement(_UploadStatusPane.StyledUploadStatusListItemBody, null, source.sourceId), _react["default"].createElement(_UploadStatusPane.StyledPaneIcon, null, source.status === _SourceUploadStatus.UPLOADING ? _react["default"].createElement(_reactstrap.Spinner, {
      size: "lg",
      color: "primary"
    }) : _react["default"].createElement(_UploadStatusPane.StyledFontAwesomeIcon, {
      icon: iconMap[source.status],
      color: _UploadStatusPane.colorMap[source.status],
      size: "2x"
    })));
  })));
};
UploadStatusPane.propTypes = {
  isVisible: _propTypes["default"].bool.isRequired,
  uploadStatus: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    sourceId: _propTypes["default"].string.isRequired,
    status: _propTypes["default"].oneOf([_SourceUploadStatus.UPLOAD_FAILED, _SourceUploadStatus.UPLOADED, _SourceUploadStatus.UPLOADING]).isRequired
  })).isRequired,
  onPanelClose: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = UploadStatusPane;